import PropTypes from 'prop-types';
import React from 'react';
import Rating from 'yoda-core-components/lib/components/Rating/rating';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

const ReviewAndRating = (props) => {
    const { productUrl, onProductClick, rating, cardTheme } = props;

    let { reviewCount } = props;
    if (typeof reviewCount === 'string') {
        reviewCount = parseInt(reviewCount, 10);
    }

    const ratingClass = rating !== null ? `${dt(['min-h-[25px]'])}` : '';

    const displayRatingCount = () => {
        if (reviewCount > 0) {
            return (
                <span
                    className={dt(['text-small', 'p-0.5', 'relative', 'top-0.5', 'underline'])}
                    data-automation-id="reviewCount"
                >
                    {reviewCount.toLocaleString()}
                </span>
            );
        }
        return null;
    };

    const displayReviewRating = () => {
        if (rating > 0) {
            return (
                <Rating
                    averageRating={rating}
                    totalRatings={5}
                    ratingIconSize="small"
                    wrapperClassName={dt(['!inline-block'])}
                    automationId="productCard-automation-rating"
                />
            );
        }
        return null;
    };

    return productUrl ? (
        <a
            href={productUrl}
            className={ratingClass}
            data-automation-id="ratingWrapper"
            onClick={(e) => {
                onProductClick(e, 'reviews');
            }}
        >
            {displayReviewRating()}
            {displayRatingCount()}
        </a>
    ) : (
        <div className={ratingClass} data-automation-id="ratingWrapper">
            {displayReviewRating()}
            {displayRatingCount()}
        </div>
    );
};

ReviewAndRating.defaultProps = {
    productUrl: '',
    onProductClick: () => {},
    rating: 0,
    reviewCount: 0,
    cardTheme: '',
};

ReviewAndRating.propTypes = {
    reviewCount: PropTypes.number,
    rating: PropTypes.number,
    productUrl: PropTypes.string,
    onProductClick: PropTypes.oneOfType([PropTypes.func]),
    cardTheme: PropTypes.string,
};

export default ReviewAndRating;
